/// <amd-module name="Comments/Item/CommentItem" />
export { CommentItem } from "Comments/Item/Components/CommentItem";
export { ICommentItemProps } from "Comments/Item/Components/CommentItem.Props";
